import { getCookie } from '../../services/NetworkUtils'

// Same key Register/Login/Forget-password use for the pending user id.
const USER_ID_KEY = 'RrwF57&aRMoR5Eq23#Mi'

/**
 * Forget the persisted signup wizard so the next /register starts at step 1.
 *
 * Register/index.jsx resumes at `register_active_step` (>= 3) whenever the
 * user-id key also exists, so both must go. The user-id key is shared with the
 * login flow (Login/Context.jsx sets it on every sign-in), so it is only
 * dropped when there is no live session token — clearing it under a logged-in
 * session would break that session's own reads of it.
 *
 * Reload-resume is unaffected: this only runs on an explicit exit from the
 * wizard (step-4 "Back to log in", or "Sign up" on the Login page).
 */
export function clearRegisterDraft() {
  try {
    localStorage.removeItem('register_active_step')
    localStorage.removeItem('countdown_to_new_otp')
    if (!getCookie('token-backoffice')) localStorage.removeItem(USER_ID_KEY)
  } catch (err) {
    console.warn(err)
  }
}
